import { render, staticRenderFns } from "./ButtonTest.vue?vue&type=template&id=992e243a"
import script from "./ButtonTest.vue?vue&type=script&lang=js"
export * from "./ButtonTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports